import { observer } from 'mobx-react-lite'
import { Dropdown } from 'shared/ui'
import { useBreakdownFilterContext } from './context/breakdownFilterContext'
import { BreakdownFilterDropdownContent } from './ui/BreakdownFilterContent/BreakdownFilterDropdownContent'
import { BreakdownFilterTrigger } from './ui/BreakdownFilterTrigger/BreakdownFilterTrigger'

type BreakdownFilterDropdownProps = {
  parentWidth?: number
}

export const BreakdownFilterDropdown = observer(({ parentWidth }: BreakdownFilterDropdownProps) => {
  const { onBreakdownToggle, isOpen, hasFilters } = useBreakdownFilterContext()

  return (
    <Dropdown
      show={isOpen}
      onToggle={onBreakdownToggle}
      placement='bottom-start'
      width={hasFilters ? parentWidth : undefined}
      triggerComponent={(open) => <BreakdownFilterTrigger active={open} />}
      customComponent={(_onClose, parentsDropdownId) => (
        <BreakdownFilterDropdownContent parentsDropdownId={[parentsDropdownId]} />
      )}
    />
  )
})
